/**
 * Analytics service - single entry point for tracking (aligned with other products).
 * Use MixpanelService.track("event_name", { key: value }) with snake_case event names and props.
 */
import { trackEvent, setEventContext } from "./mixpanel";

export const MixpanelService = {
  /**
   * Track an event. Context (user_id, project_id, etc.) is merged automatically.
   * @param {string} eventName - snake_case event name, e.g. "filter_label_used", "login_submitted"
   * @param {object} properties - event properties (snake_case keys), e.g. { label, action, selected_labels }
   */
  track(eventName, properties = {}) {
    trackEvent(eventName, properties);
  },

  /**
   * Set context sent with every subsequent track call. Call from App when user/project changes.
   * @param {object} context - e.g. { user_id, project_id, organisation_id, environment }
   */
  setContext(context = {}) {
    setEventContext(context);
  },
};

export default MixpanelService;
